import { id } from '@monorepo/tools/src/lib/types/primitives';
import { CrudEndpoint } from './crud.endpoint';

export class NotificationsPageEndpoint extends CrudEndpoint {
	constructor() {
		super('notifications');
	}

	private scopedBaseUrl(accountId?: id | null) {
		return accountId ? `${this.baseUrl}/account/${accountId}` : this.baseUrl;
	}

	campaignAvailabilityAffectedCount(accountId?: id | null) {
		return `${this.scopedBaseUrl(accountId)}/campaign-availability/summary`;
	}

	campaignAvailabilityAffectedCampaigns(accountId?: id | null) {
		return `${this.scopedBaseUrl(accountId)}/campaign-availability/campaigns`;
	}
}
